// extracted by mini-css-extract-plugin
module.exports = {"directoryCardContainer":"DirectoryCardArea_directoryCardContainer__l6pQu","fillColor":"DirectoryCardArea_fillColor__2gP1a"};